import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';

function ReportTypeSelect({ reportType, onSelect }) {
  return (
    <div className="flex m-r-16">
      <div className="text-muted m-r-16">Report Type</div>
      <ButtonToolbar style={{ width: '160px' }}>
        <DropdownButton
          bsStyle="info"
          title={`${reportType === 'heat' ? 'Heat Map' : 'Pie Chart'}`}
          id="status-filter"
          className="btn-block text-capitalize"
          onSelect={(val) => onSelect(val)}
          pullRight
        >
          <MenuItem active={reportType === 'pie'} eventKey="pie">
            Pie Chart
          </MenuItem>
          <MenuItem active={reportType === 'heat'} eventKey="heat">
            Heat Map
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ReportTypeSelect;
